export enum ClaimableCampaignsActionTypes {
  FETCHING = 'claimableCampaign/FETCHING',
  RECEIVED = 'claimableCampaign/RECEIVED ',
  ERROR = 'claimableCampaign/FETCH-ERROR',
  POLLING = 'claimableCampaign/POLLING',
  JOIN_LEFT_ERROR = 'claimableCampaign/JOIN_LEFT_ERROR',
  JOIN_LEFT_SUCCESS = 'claimableCampaign/JOIN_LEFT_SUCCESS',
  JOIN_LEFT_REQUEST = 'claimableCampaign/JOIN_LEFT_REQUEST',
}
